export const projects = [
    {
      title: "Clothing-App",
      subtitle: "MERN Stack",
      description:
        "An e-commerce shopping application with Stripe payment link and download link for the payment receipt!",
      image: "./shopoholic1.gif",
      link: "https://fashion-shopping-app.netlify.app/"
    },
    {
      title: "Raven-Hunt",
      subtitle: "HTML-Canvas / Sprite-Animation-Game",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./RavenHunt.gif",
      link: "https://ritahc.github.io/Raven-Hunt/",
    },
    {
      title: "Food-App",
      subtitle: "MongoDb and Liquid",
      description:
        "Food Ordering application for a restraunt",
      image: "./foodApp.gif",
      link: "https://projectfood.fly.dev/"
    },
    {
      title: "Particle Effect Game",
      subtitle: "HTML Canvas / CSS/ Java Script",
      description:
        "New Particles keeps appearing as the cursor moves",
      image: "./ParticleEffect.gif",
      link: "https://ritahc.github.io/Particle-Animation/",
    },
    {
      title: "Advice-Generator",
      subtitle: "3rd-Party-API-Call",
      description:
        "Upon Clicking the diced button, every time a new text appearts in the advice box",
      image: "./AdviceGenerator.gif",
      link: "https://ritahc.github.io/Advice-Generator-/",
    },
    {
      title: "Burger-Stacker",
      subtitle: "React-Hooks",
      description:
        "Upon Clicking the ingredients on the left side, one can create a burger stacker on the right side and also clear it",
      image: "./BurgerStacker.gif",
      link: "https://coruscating-fox-9cd2b3.netlify.app/"
    },
    {
      title: "House-Of-Dragons-Fanpage",
      subtitle: "JavaScript-HTML-CSS",
      description:
        "Browse and view the details of your favourite character though our search functionality",
      image: "./houseOfDragon.gif",
      link: "https://ritahc.github.io/House-Of-Dragon-Fanpage/"
    },
    {
      title: "Tic-Tac-Toe",
      subtitle: "JavaScript-HTML-CSS",
      description:
        "Our simple and userfriendly Tic-Tac-Toe-Game",
      image: "./TicTacToe.gif",
      link: "https://ritahc.github.io/Tic-Tac-Toe-Project/"
    },
  ];

  export const skills = [
     "JavaScript", "Go", "Python", "Next.js", "React", "MongoDb", "PostgreSQL", "Node.js", "Express.js", "Django", "npm & it's packages", "Github", "Jira", "Bitbucket", "Bootstrap", "Tailwind"
  ]

  export const testimonials = [
    {
      quote: 'My name is Shania Eaglin, Career Coach and Outcomes Instructor here at GA. I have the pleasure of working with Rita as her Career Coach and I highly recommend her for the TA position. She is super dependable, determined, great at communication, and highly resourceful. She was great to work with in class due to her high participation, willingness to display leadership, and ability to prove responsible with instruction. I believe Rita would make an awesome addition to an Instructional team and I hope that you all will consider her for the position. Please feel free to contact me via email if you need any additional information: shania.eaglin@generalassemb.ly',
      image: 'https://media.licdn.com/dms/image/v2/D5603AQHDrygwlQzjew/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1639473156198?e=1743033600&v=beta&t=nwnDxtiRNY1FxpRkdYOXyH0CvwyiR7cAX0yfkv0AVVA',
      name: 'Shania Eaglin',
      company: 'General Assembly',
      linkedin: 'https://www.linkedin.com/in/shaniaeaglin/'
    }, 
    {
      quote: 'While working with Rita during her time at General Assembly, I saw her dedication to learning and teaching others. Even though I was an Instructional Associate who helped guide students during the software engineering bootcamp, she often taught me something new as she attempted and succeeded in implementing additional features into her projects. Additionally, whenever she encountered an obstacle, she was never afraid to reach out for help after spending time on her own researching a solution. Rita went above and beyond what was expected of her and challenged herself to learn things outside of the scope of the bootcamp. This led to her gaining a deeper understanding of concepts which will undoubtedly help her in any role she pursues. Any company would be fortunate to have a hard-working and talented individual like Rita who often exceeds expectations while also remaining humble and appreciative of any feedback given. I look forward to seeing where she ends up next on her journey.',
      image: 'https://media.licdn.com/dms/image/v2/C5603AQGqDQMnfW4YvA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1624989643290?e=1743033600&v=beta&t=RA5Iy_gHUI8nbO2Z_01WU_TFX7el2IyYNKSnWOYNIP4',
      name: 'Ashley Sands',
      company: 'General Assembly',
      linkedin: 'https://www.linkedin.com/in/ashley-sands/'
    }
  ]